import { render, staticRenderFns } from "./ReturnOrderList.vue?vue&type=template&id=37615020&scoped=true&"
import script from "./ReturnOrderList.vue?vue&type=script&lang=js&"
export * from "./ReturnOrderList.vue?vue&type=script&lang=js&"
import style0 from "./ReturnOrderList.vue?vue&type=style&index=0&id=37615020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37615020",
  null
  
)

export default component.exports